import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';

import NotFound from '../NotFound';
import ShowView from './ShowView';

const MyPerformancePage = ({ match: { path } }) => (
  <Switch>
    <Route exact path={path} component={ShowView} />
    <Route component={NotFound} />
  </Switch>
);

MyPerformancePage.propTypes = {
  match: PropTypes.shape({
    path: PropTypes.string,
  }),
};

export default MyPerformancePage;
